// src/services/enhancedLawLabels.js

/**
 * Enhanced, user-friendly law labels that replace the confusing "NEG. LAW:" format
 * These are used in the expanded details sections
 */

export const enhancedLawLabels = {
    1: 'Marriage equality recognized',
    2: 'Civil unions recognized', 
    3: 'Second parent adoption for unmarried couples',
    4: 'Adoption non-discrimination protections for LGBTQ+ parents',
    5: 'Foster care non-discrimination protections for LGBTQ+ parents',
    6: 'Recognition for parents using assisted reproduction',
    7: 'LGBTQ+-inclusive definitions of spouse/partner for family medical leave',
    8: 'LGBTQ+-inclusive definitions of children/parents for family medical leave',
    9: 'Employment non-discrimination protections',
    10: 'Housing non-discrimination protections',
    11: 'Public accommodation non-discrimination protections',
    12: 'Credit non-discrimination protections',
    13: 'Non-discrimination policies for state employees',
    14: 'State allows cities/counties to pass non-discrimination laws',
    15: 'Transgender people can use bathrooms consistent with gender identity in government buildings',
    16: 'State does NOT explicitly define "sex" to exclude transgender people',
    17: 'State does NOT have broad religious freedom restoration acts that could override LGBTQ+ protections',
    18: 'State does NOT allow religious exemptions for child welfare services',
    19: 'State does NOT allow religious exemptions for medical professionals',
    20: 'State does NOT allow religious exemptions for wedding services',
    21: 'State does NOT allow religious exemptions for marriage license officials',
    22: 'Non-discrimination laws covering LGBTQ+ students',
    23: 'Anti-bullying laws covering LGBTQ+ students',
    24: 'State allows local schools to pass LGBTQ+ protections',
    25: 'State curriculum standards are LGBTQ+-inclusive',
    26: 'State does NOT have "Don\'t Say Gay" laws restricting LGBTQ+ discussion',
    27: 'State does NOT require parental opt-out for LGBTQ+-inclusive curricula',
    28: 'State allows discussion of LGBTQ+ topics in schools',
    29: 'Transgender students can participate in sports consistent with gender identity',
    30: 'State allows transgender students to use facilities consistent with gender identity',
    31: 'State does NOT require forced outing of transgender youth in schools',
    32: 'State allows comprehensive sex education including LGBTQ+ topics',
    33: 'Protections for LGBTQ+ youth in child welfare system',
    34: 'Private health insurance non-discrimination laws',
    35: 'State allows transgender-specific care for youth',
    36: 'Shield laws protecting access to transgender health care',
    37: 'Health insurance providers banned from excluding transgender coverage',
    38: 'State Medicaid covers transgender-specific care',
    39: 'Transgender-inclusive health benefits for state employees',
    40: 'Data collection includes LGBTQ+ adults',
    41: 'Data collection includes LGBTQ+ youth',
    42: 'Fertility treatment coverage in private insurance',
    43: 'Fertility treatment coverage in Medicaid',
    44: 'Fertility preservation coverage in private insurance',
    45: 'Fertility preservation coverage in Medicaid',
    46: 'Hate crime laws covering LGBTQ+ people',
    47: 'Ban on "panic defense" in criminal cases',
    48: 'Jury service non-discrimination',
    49: 'State does NOT criminalize HIV status',
    50: 'State does NOT restrict drag performances',
    51: 'Can change gender marker on driver\'s license',
    52: 'Can change gender marker on birth certificate',
    53: 'Non-binary "X" option available on driver\'s licenses',
    54: 'Non-binary "X" option available on birth certificates',
    55: 'Streamlined name change process available',
    56: 'State recognizes out-of-state same-sex marriages',
    57: 'State recognizes out-of-state adoption by same-sex couples',
    58: 'State allows joint adoption by same-sex couples',
    59: 'State allows single LGBTQ+ individuals to adopt',
    60: 'State prohibits discrimination in adoption agencies',
    61: 'State prohibits conversion therapy for minors',
    62: 'State funding for LGBTQ+ youth services',
    63: 'State anti-discrimination training for educators',
    64: 'State hate crime data collection includes LGBTQ+ status',
    65: 'State domestic violence laws include same-sex couples',
    66: 'State elder abuse laws include LGBTQ+ protections',
    67: 'State HIV criminalization reform enacted',
    68: 'Conversion therapy ban covering LGBTQ+ youth'
  };
  
  // Helper function to get enhanced law label
  export const getEnhancedLawLabel = (lawId) => {
    return enhancedLawLabels[lawId] || `Law ${lawId}`;
  };
  
  // Map negative laws that need status inversion
  export const negativeLaws = new Set([14, 15, 16, 17, 18, 19, 20, 21, 26, 27, 31, 49, 50]);
  
  export default {
    enhancedLawLabels,
    getEnhancedLawLabel,
    negativeLaws
  };